import React from 'react';

export default function PanelGrid({ agents, states, focusedAgent, onFocus, onSwitchAgent }) {
  return (
    <div className="panel-grid" data-testid="panel-grid">
      {agents.map((a) => {
        const st = states[a.id] || {};
        // Backend returns finalConfidenceScore on a 0-100 scale already (see *_brain/scoring.py).
        // Earlier Nova/Karbon code returns 0-1 — accept both shapes.
        const rawConf = st.scoring?.finalConfidenceScore ?? st.scoring?.final_confidence_score ?? 0;
        const conf = Math.round(rawConf > 1 ? rawConf : rawConf * 100);
        const sev = st.state?.level || st.state?.severity || 'NOMINAL';
        const signalCount =
          st.signal_count ?? st.signalCount ?? st.signals_count ??
          (Array.isArray(st.insights) ? st.insights.length : null) ??
          st.insights_count ?? '—';
        const latestLine = st.state?.latest_line
          || st.state?.summary
          || st.latest_assessment
          || 'Awaiting live signal…';
        const focused = focusedAgent === a.id;
        return (
          <div
            key={a.id}
            className={`panel-card ${focused ? 'is-focused' : ''}`}
            style={{ color: a.color }}
            onClick={() => onFocus && onFocus(focused ? null : a.id)}
            onDoubleClick={() => onSwitchAgent && onSwitchAgent(a.id)}
            data-testid={`panel-card-${a.id}`}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div className="orb">{a.name.slice(0, 1)}</div>
              <div style={{ flex: 1 }}>
                <div className="name" data-testid={`panel-name-${a.id}`}>{a.name}</div>
                <div className="role">{a.role}</div>
              </div>
              <span className="studio-chip" style={{ color: 'currentColor', borderColor: 'currentColor' }}>{sev}</span>
            </div>

            <div>
              <div className="metric"><span className="k" style={{ color: 'var(--studio-text-2)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Confidence</span>
                <span className="v" style={{ fontFamily: 'var(--font-display)', color: 'var(--studio-text-0)' }}>{conf}%</span>
              </div>
              <div className="studio-bar"><i style={{ width: `${conf}%`, background: 'currentColor' }} /></div>
            </div>

            <div className="metric">
              <span className="k" style={{ color: 'var(--studio-text-2)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Signals</span>
              <span className="v" style={{ color: 'var(--studio-text-0)' }}>{signalCount}</span>
            </div>

            <div className="line" data-testid={`panel-line-${a.id}`}>{latestLine}</div>

            <div style={{
              fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase',
              color: 'var(--studio-text-3)', marginTop: -4,
            }}>
              click to focus · double-click to open
            </div>
          </div>
        );
      })}
    </div>
  );
}
